import script from "./AuthNoticePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthNoticePanel.vue?vue&type=script&setup=true&lang=js"

import "./AuthNoticePanel.vue?vue&type=style&index=0&id=14d1d48a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d1d48a"]])

export default __exports__